module.exports = __webpack_public_path__ + "img/1278676027.9a63488c.jpg";